import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-616781c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = { class: "font-weight-bold text-subtitle-1" }
const _hoisted_3 = { class: "py-n2 pl-0" }
const _hoisted_4 = {
  key: 0,
  class: "py-n2 text-center font-weight-bold"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "py-n2 text-center font-weight-bold" }, "View Service", -1 /* HOISTED */))
const _hoisted_6 = { class: "pl-0" }
const _hoisted_7 = { class: "text-subtitle-1" }
const _hoisted_8 = {
  key: 0,
  class: "text-center"
}
const _hoisted_9 = {
  class: "text-center font-weight-bold text-decoration-underline",
  style: {"color":"#C37C1B"}
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 2,
  class: "text-subtitle-1 text-center pa-4"
}

import { ref, computed, watch, onMounted, PropType } from 'vue';
import { useRouter,useRoute } from 'vue-router';
import crApi from "../service/CrApi";
import securityService from "../service/SecurityService";
import spinner from "../component/SpinnerComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceSelectorComponent',
  props: {
  modelValue: Array as PropType<string[]>,
  servicesSearchText: String,
  selectAll: Boolean,
  selectedServicesCheckbox: Boolean,
  deletedServices: Boolean,
  usage: String
},
  emits: ['update:modelValue', 'update:selectAll'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const route: any = useRoute();
const props = __props;

const emit = __emit;

const isLoading = ref(false);
const offset = ref(0);
const limit = ref(6);
const servicesSearch = ref(props.servicesSearchText || '');
const debouncedServicesSearch = ref(servicesSearch.value);

const checkAllServices = ref(props.selectAll ? true : false);
const services = ref([]);
const selectedServicesShow = ref(false);
const selectedServicesIds = ref<any>(props.modelValue);
const reloadInfiniteScroll = ref(1);

onMounted(async () => {
  await loadMore({}, true, false);
  if(route.query?.showSelectedService == 1) {
    selectedServicesShow.value = true;
  } else if(route.query?.showSelectedService == 0) {
    selectedServicesShow.value = false;
  }
  if(props.usage == 'scan-filter') {
    if(props.selectAll) {
      selectedServicesIds.value = services.value.map(service => service.serviceId);
    }
  }
  updateCheckAllState();
});

watch(servicesSearch, (newSearch) => {
  debounceSearch(newSearch);
});

watch(() => selectedServicesIds.value, () => {
  updateCheckAllState();
  emit('update:modelValue', selectedServicesIds.value);
});

watch(() => selectedServicesShow.value, async () =>{
  services.value = [];
  offset.value = 0;
  reloadInfiniteScroll.value++;

  await loadMore({}, true, false);
  updateCheckAllState();
});

async function loadMore({ done }: { done?: (arg: string) => void } = {}, firstLoad = false, search = false) {
  if (isLoading.value) {
    return;
  }
  isLoading.value = true;
  try {
    let response;
    if(!selectedServicesShow.value) {
      response = await crApi.requestV2('service/retrieve/', {
        sortBy: 'servicename',
        response: 'extra',
        sortOrder: 'asc',
        website_token: securityService.getToken(),
        excludeTypes: ['webview', 'scanwedge'],
        offset: offset.value,
        limit: limit.value,
        serviceName: debouncedServicesSearch.value
      });
    } else {
      if(selectedServicesIds.value.length > 0) {
        response = await crApi.requestV2('service/retrieve/', {
          website_token: securityService.getToken(),
          serviceName: debouncedServicesSearch.value,
          offset: offset.value,
          limit: limit.value,
          serviceId: selectedServicesIds.value,
        });
      } else {
        response = { status: 1, service: [] };
      }
    }

    if (response && response.status === 1) {
      services.value.push(...response.service);
      offset.value += limit.value;

      if (done) {
        done(response.service.length < limit.value ? 'empty' : 'done');
      }
    }
  } catch (error) {
    console.error('Error loading services:', error);
  } finally {
    isLoading.value = false;
    updateCheckAllState();
  }
}

let debounceTimeout: ReturnType<typeof setTimeout>;
function debounceSearch(newSearch: string) {
  clearTimeout(debounceTimeout);
  debounceTimeout = setTimeout(() => {
    debouncedServicesSearch.value = newSearch;
    offset.value = 0;
    services.value = [];
    reloadInfiniteScroll.value++;
    loadMore({}, false, true);
  }, 1000);
}

function checkAll() {
  if (checkAllServices.value) {
    selectedServicesIds.value = services.value.map(service => service.serviceId);
  } else {
    selectedServicesIds.value = [];
  }
  emit('update:modelValue', selectedServicesIds.value);
  emit('update:selectAll', checkAllServices.value);
}

function updateCheckAllState() {
  if (services.value.length > 0 && services.value.every(service => selectedServicesIds.value.includes(service.serviceId))) {
    checkAllServices.value = true;
  } else {
    checkAllServices.value = false;
  }
}

function serviceName(name: string) {
  return name.length > 29 ? `${name.substring(0, 29)}...` : name;
}
function goEditServicePage(serviceId) {
  router.push({ path: `/account/services/${serviceId}/type/` });
}

function clearSearch() {
  servicesSearch.value = '';
  checkAllServices.value = selectedServicesIds.value.length === services.value.length;
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_text_field, {
      "prepend-inner-icon": "mdi-magnify",
      modelValue: servicesSearch.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((servicesSearch).value = $event)),
      placeholder: "Search Services",
      clearable: "",
      "onClick:clear": clearSearch,
      density: "compact",
      variant: "outlined"
    }, null, 8 /* PROPS */, ["modelValue"]),
    (props.usage != 'scan-filter')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_btn, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedServicesShow.value = false)),
            class: _normalizeClass(["text-none rounded-md mr-2 border-md font-weight-medium", { 'activeBtn': selectedServicesShow.value == false }]),
            variant: "flat"
          }, {
            default: _withCtx(() => [
              _createTextVNode("View All Services")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["class"]),
          _createVNode(_component_v_btn, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedServicesShow.value = true)),
            class: _normalizeClass(["text-none rounded-md border-md font-weight-medium", { 'activeBtn': selectedServicesShow.value == true }]),
            variant: "flat"
          }, {
            default: _withCtx(() => [
              _createTextVNode("View Selected Services " + _toDisplayString(selectedServicesIds.value.length > 0 ? `(${selectedServicesIds.value.length})` : ''), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["class"])
        ]))
      : _createCommentVNode("v-if", true),
    (!(selectedServicesShow.value && selectedServicesIds.value == 0 ))
      ? (_openBlock(), _createBlock(_component_v_infinite_scroll, {
          key: reloadInfiniteScroll.value,
          color: "black",
          mode: "manual",
          onLoad: loadMore,
          "load-more-text": "Load More Services"
        }, {
          empty: _withCtx(() => [
            _createTextVNode(" No more results ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_table, {
              style: {"height":"100%","max-height":"450px"},
              "fixed-header": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_2, [
                    _createElementVNode("th", _hoisted_3, [
                      _createVNode(_component_v_checkbox, {
                        color: "#F7CC4F",
                        class: "font-weight-bold",
                        "hide-details": "",
                        label: "  Services",
                        modelValue: checkAllServices.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checkAllServices).value = $event)),
                        onChange: checkAll,
                        density: "compact"
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    (props.usage != 'scan-filter')
                      ? (_openBlock(), _createElementBlock("th", _hoisted_4, "Service ID"))
                      : _createCommentVNode("v-if", true),
                    _hoisted_5
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "text-subtitle-1",
                      key: service.serviceId
                    }, [
                      _createElementVNode("td", _hoisted_6, [
                        _createVNode(_component_v_checkbox, {
                          color: "#F7CC4F",
                          density: "compact",
                          modelValue: selectedServicesIds.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedServicesIds).value = $event)),
                          value: service.serviceId,
                          "hide-details": ""
                        }, {
                          label: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, "  " + _toDisplayString(serviceName(service.serviceName)), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "value"])
                      ]),
                      (props.usage != 'scan-filter')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(service.serviceId), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("td", _hoisted_9, [
                        _createElementVNode("span", {
                          class: "cursor-pointer",
                          onClick: ($event: any) => (goEditServicePage(service.serviceId))
                        }, "View", 8 /* PROPS */, _hoisted_10)
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, " No selected service "))
  ]))
}
}

})